function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import fetch from 'node-fetch';
import styles from './Hero.less';
import { heroImage } from '../../../shared/heroImage';
import { trackEvent } from '../../utils/tracking';
import GacContainer from '../gaccontainer/GacContainer';
import { generateSearchId } from '../../utils/searchId';
import TabContainer from '../common/tabcontainer/TabContainer';
import Tab from '../common/tabcontainer/Tab';
import TabContent from '../common/tabcontainer/TabContent';
import { changeUrl, paths, pageTitles } from '../../utils/changeUrl';
import tabs from './tabNames';
import { realtorCategories } from '../realtorCategoryDropdown/CategoryDropdown';
export var HeroBlock = function HeroBlock(_ref) {
  var apiEndPoint = _ref.apiEndPoint,
    selectedTab = _ref.selectedTab,
    setBranchenbuchSearch = _ref.setBranchenbuchSearch;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectAgentLocation = _useState2[0],
    setAgentLocationSuggestion = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectAgencyLocation = _useState4[0],
    setAgencyLocationSuggestion = _useState4[1];
  var _useState5 = useState(realtorCategories[0]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedRealtorCategory = _useState6[0],
    setSelectedRealtorCategory = _useState6[1];
  React.useEffect(function () {
    window.onpopstate = function () {
      setBranchenbuchSearch(selectedTab !== tabs.TAB2);
    };
  });
  var onTabSwitch = function onTabSwitch(tabId, path, pageTitle) {
    if (tabId === tabs.TAB1) {
      setBranchenbuchSearch(false);
    } else setBranchenbuchSearch(true);
    changeUrl(window.location.origin, path, pageTitle);
  };
  var redirectToSearchPage = function redirectToSearchPage() {
    if (!selectAgentLocation || selectAgentLocation.geoPath.uri === '') return;
    var searchId = generateSearchId();
    trackEvent({
      label: "homepage_execute_agent_search_".concat(searchId),
      name: "homepage_search_execute",
      parameter_1: "searchId_".concat(searchId)
    });
    window.location.href = "/anbieter/immobilienmakler".concat(selectAgentLocation.geoPath.uri, "?searchid=").concat(searchId, "&source=agentSearchWeb");
  };
  var redirectToBranchenbuchPage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var geoInfoData, response, data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(!selectAgencyLocation || selectAgencyLocation.geoPath.uri === '')) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            geoInfoData = {
              cityOrPostCode: selectAgencyLocation.name,
              geoCodeId: selectAgencyLocation.value,
              searchType: selectedRealtorCategory.value,
              gacId: null
            };
            if (selectAgencyLocation.type === 'postcode') {
              geoInfoData = _objectSpread(_objectSpread({}, geoInfoData), {}, {
                gacId: selectAgencyLocation.value,
                geoCodeId: null
              });
            }
            _context.n = 2;
            return fetch("https://".concat(window.location.host, "/anbieter/rest"), {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(geoInfoData)
            });
          case 2:
            response = _context.v;
            _context.n = 3;
            return response.json();
          case 3:
            data = _context.v;
            window.location.href = data.searchUrl;
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function redirectToBranchenbuchPage() {
      return _ref2.apply(this, arguments);
    };
  }();
  var sellingPointsAgentSearch = ['Seriöse und kompetente Makler', 'Bewertet von Eigentümern und Suchenden', 'Direkt kontaktieren'];
  var sellingPointsRealtorDirectory = ['Größtes Firmennetzwerk Deutschlands', 'Von Baufinanzierung bis Umzug', 'Kostenlos kontaktieren'];
  return /*#__PURE__*/React.createElement("div", {
    className: "one-whole horizontal-center ".concat(styles.heroWrapper),
    "data-testid": "hero-block"
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.heroImage,
    src: heroImage,
    alt: "",
    width: 1920,
    height: 328,
    fetchPriority: "high"
  }), /*#__PURE__*/React.createElement("div", {
    className: "six-twelfth lap-one-whole palm-one-whole horizontal-center padding-l ".concat(styles.contentWrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.headline, " ").concat(styles.fontWhite, " font-heading-large-bold")
  }, selectedTab === 'realtor_directory' ? 'Finden Sie Profis' : 'Makler gesucht?'), /*#__PURE__*/React.createElement("div", {
    className: "font-heading-large-bold ".concat(styles.fontWhite)
  }, selectedTab === 'realtor_directory' ? 'rund um Immobilien' : 'Los geht’s.'), /*#__PURE__*/React.createElement("div", {
    className: styles.searchBox
  }, /*#__PURE__*/React.createElement(TabContainer, null, /*#__PURE__*/React.createElement(Tab, {
    id: tabs.TAB1,
    value: "Makler",
    selectedTab: selectedTab,
    path: paths.AGENT_SEARCH,
    pageTitle: pageTitles.AGENT_SEARCH,
    onSelectedTab: onTabSwitch
  }), /*#__PURE__*/React.createElement(Tab, {
    id: tabs.TAB2,
    value: "Branchenbuch",
    selectedTab: selectedTab,
    path: paths.BRANCHENBUCH,
    pageTitle: pageTitles.BRANCHENBUCH,
    onSelectedTab: onTabSwitch
  })), /*#__PURE__*/React.createElement(TabContent, {
    selectedTab: selectedTab,
    tabId: tabs.TAB1
  }, /*#__PURE__*/React.createElement(GacContainer, {
    apiEndPoint: apiEndPoint,
    placeholder: "Wo suchen Sie?",
    buttonText: "Makler finden",
    id: "home-page-agent-search",
    onSuggestionSelected: setAgentLocationSuggestion,
    onButtonClick: redirectToSearchPage,
    isBranchenbuchSearch: false,
    onCategorySelected: setSelectedRealtorCategory,
    selectedCategory: selectedRealtorCategory
  })), /*#__PURE__*/React.createElement(TabContent, {
    selectedTab: selectedTab,
    tabId: tabs.TAB2
  }, /*#__PURE__*/React.createElement(GacContainer, {
    apiEndPoint: apiEndPoint,
    placeholder: "Wo suchen Sie?",
    buttonText: "Anbieter finden",
    id: "home-page-realtor-directory",
    onSuggestionSelected: setAgencyLocationSuggestion,
    onButtonClick: redirectToBranchenbuchPage,
    nextgenData: false,
    isBranchenbuchSearch: true,
    onCategorySelected: setSelectedRealtorCategory,
    selectedCategory: selectedRealtorCategory
  })))), /*#__PURE__*/React.createElement("div", {
    className: "one-whole align-center ".concat(styles.upsBlock),
    "data-testid": "ups-block"
  }, selectedTab === tabs.TAB1 ? sellingPointsAgentSearch.map(function (item, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index
    }, /*#__PURE__*/React.createElement("i", {
      className: "is24-icon-positive-check",
      "aria-hidden": true
    }), item);
  }) : sellingPointsRealtorDirectory.map(function (item, index) {
    return /*#__PURE__*/React.createElement("span", {
      key: index
    }, /*#__PURE__*/React.createElement("i", {
      className: "is24-icon-positive-check",
      "aria-hidden": true
    }), item);
  })));
};